import axios from 'axios';
import swal from 'sweetalert';
import Cookies from 'universal-cookie';
import config from '../common/config';

export default async function callApi(
  endpoint,
  method = 'GET',
  body,
  header = null,
  onError
) {
  var cookies = new Cookies();
  const status = navigator.onLine;
  if (status == false) {
    swal(
      'Đường truyền mạng không ổn định. Vui lòng xem lại đường truyền kết nối mạng.'
    );
    return false;
  }

  return await axios({
    method: method,
    url: endpoint,
    data: body,
    withCredentials: true,
    headers: header
  }).catch(function (error) {
    if (error.response) {
      if (
        window.location.pathname == '/dang-nhap' &&
        error.response.status == 401
      ) {
        window.localStorage.removeItem('user_store');
        window.localStorage.removeItem('phone_number');
        window.localStorage.removeItem('course_id');
        window.localStorage.removeItem('register_info');

        config.DeleteDataIntoCache('user_store', '/');
        config.DeleteDataIntoCache('is_logged', '/');
        window.localStorage.removeItem('AccessToken');

        // Clear user data cache
        window.localStorage.removeItem('user_cache_timestamp');
        window.localStorage.removeItem('cached_user_data');
        window.localStorage.removeItem('cached_access_token');
        window.localStorage.removeItem('cached_data_hash');

        cookies.remove('user_store');
        cookies.remove('AccessToken');
        cookies.remove('access_token');
        cookies.remove('OTPStore');
        cookies.remove('showblur');
        // swal("",error.response.data.errors[0].message, "warning", {
        //     button: "OK",
        //   });
        if (typeof onError === 'function') onError(error);
        return false;
      }
      if (window.location.pathname == '/' && error.response.status == 401) {
        // temp so
        window.localStorage.removeItem('user_store');
        window.localStorage.removeItem('phone_number');
        window.localStorage.removeItem('course_id');
        window.localStorage.removeItem('register_info');

        config.DeleteDataIntoCache('user_store', '/');
        config.DeleteDataIntoCache('is_logged', '/');
        window.localStorage.removeItem('AccessToken');

        // Clear user data cache
        window.localStorage.removeItem('user_cache_timestamp');
        window.localStorage.removeItem('cached_user_data');
        window.localStorage.removeItem('cached_access_token');
        window.localStorage.removeItem('cached_data_hash');

        cookies.remove('user_store');
        cookies.remove('AccessToken');
        cookies.remove('access_token');
        cookies.remove('OTPStore');
        cookies.remove('showblur');
        // swal('', error.response.data.errors[0].message, 'warning', {
        //   button: 'OK'
        // });
        if (typeof onError === 'function') onError(error);
        return false;
      }
      if (
        window.location.pathname == '/' ||
        window.location.pathname == '/huong-dan'
      ) {
        return false;
      }
      if (error.response.status == 401) {
        // Special handling for required password change
        const errorCode = error.response.data?.errors?.[0]?.code;
        if (errorCode === 'required_change_password_exception') {
          // Don't clear data, just redirect to password change page
          swal({
            text: error.response.data.errors[0].message,
            icon: 'warning',
            buttons: true,
            dangerMode: true
          }).then((willDelete) => {
            window.location.href = '/doi-mat-khau';
          });
          if (typeof onError === 'function') onError(error);
          return false;
        }

        // For other 401 errors, clear data and redirect to login
        window.localStorage.removeItem('user_store');
        window.localStorage.removeItem('phone_number');
        window.localStorage.removeItem('course_id');
        window.localStorage.removeItem('register_info');

        config.DeleteDataIntoCache('user_store', '/');
        config.DeleteDataIntoCache('is_logged', '/');
        window.localStorage.removeItem('AccessToken');

        // Clear user data cache
        window.localStorage.removeItem('user_cache_timestamp');
        window.localStorage.removeItem('cached_user_data');
        window.localStorage.removeItem('cached_access_token');
        window.localStorage.removeItem('cached_data_hash');

        cookies.remove('user_store');
        cookies.remove('AccessToken');
        cookies.remove('access_token');
        cookies.remove('OTPStore');
        cookies.remove('showblur');
        // 401: re login
        swal({
          text: error.response.data.errors[0].message,
          icon: 'warning',
          buttons: true,
          dangerMode: true
        }).then((willDelete) => {
          window.location.href = '/dang-nhap';
        });
      }
      if (
        error.response.status == 400 ||
        error.response.status == 500 ||
        error.response.status == 403 ||
        error.response.status == 408
      ) {
        if (typeof onError === 'function') {
          const skipDefault = onError(error);
          if (skipDefault === false) {
            return false;
          }
        }
        if (error.response.data == '') {
          return false;
        }
        var msg = error.response.data.errors[0].message;
        switch (msg) {
          case 'code not valid':
            msg = 'Mã xác thực không đúng.';
            break;
          case 'password must contain at least eight characters, including at least one number, one uppercase English letter, one lower case English letter and one special character':
            msg =
              'Mật khẩu phải chứa ít nhất 8 ký tự, bao gồm ít nhất một số, một chữ cái viết hoa, một chữ cái viết thường và một ký tự đặc biệt. Vui lòng thử lại.';
            break;
          default:
            break;
        }

        // 403 You don't have permission to access
        if (
          error.response.data.errors[0].code == 'exam_rule_violated_exception'
        ) {
          swal({
            text: error.response.data.errors[0].message,
            icon: 'warning',
            buttons: true,
            dangerMode: true
          }).then((willDelete) => {
            window.location.href = '/de-thi-can-lam';
          });
          return 1;
        }

        swal('', msg, 'warning', {
          button: 'OK'
        });
        return false;
      }
    }
  });
}
